import { LoadingButton } from '@mui/lab';
import { Stack, TextField, Typography } from '@mui/material';

const DepartureQuantityStep = ({
  busy,
  register,
  handleSubmit,
  errors,
  isSubmitted,
  validateQuantity,
  availableQuantity,
  onSubmit,
}) => {
  return (
    <Stack gap={2} py={1}>
      <TextField
        label="تعداد برداشت"
        type="number"
        fullWidth
        inputProps={{ min: 1 }}
        {...register('quantity', {
          required: 'تعداد برداشت الزامی است.',
          validate: validateQuantity,
        })}
        error={isSubmitted ? !!errors.quantity : false}
        helperText={errors.quantity?.message || ''}
      />

      {availableQuantity != null ? (
        <Typography variant="body2" color="text.secondary">
          موجودی: {availableQuantity}
        </Typography>
      ) : null}

      <LoadingButton
        variant="contained"
        loading={busy}
        onClick={handleSubmit(onSubmit)}
      >
        برداشت
      </LoadingButton>
    </Stack>
  );
};

export default DepartureQuantityStep;
